// Stable names in the reviewed Family Chantel / Darcey & Stacey extensions.
export const canonCastNames: Record<string, string> = {
  'p-karen-everett': 'Karen Everett', 'p-thomas-everett': 'Thomas Everett',
  'p-river-everett': 'River Everett', 'p-winter-everett': 'Winter Everett',
  'p-lidia-morel': 'Lidia Morel', 'p-nicole-jimeno': 'Nicole Jimeno',
  'p-royal-everett': 'Royal Everett', 'p-angenette-everett': 'Angenette Everett',
  'p-jah-family-chantel': 'Jah', 'p-alejandro-padron': 'Alejandro Padron',
  'p-megan-family-chantel': 'Megan', 'p-scott-wern': 'Scott Wern',
  'p-georgi-rusev': 'Georgi Rusev', 'p-mike-silva': 'Mike Silva',
  'p-nancy-silva': 'Nancy Silva', 'p-aniko-bollok': 'Aniko Bollok',
  'p-aspen-bollok': 'Aspen Bollok', 'p-michael-benz': 'Michael Benz',
  'p-debbie-darcey-stacey': 'Debbie', 'p-reina-darcey-stacey': 'Reina',
}
